import React from "react";
import { Link } from "react-router-dom";

import getAppFooterText from "../../../../shared/utils/appFooterText";
import styles from "../Footer.module.scss";

const TermosDireitos = () => (
    <>
        <div className={styles.termsLinks}>
            <Link to="#">Política de Privacidade</Link>
            <Link to="#">Termos de Uso</Link>
        </div>
        <span>{getAppFooterText()}</span>
    </>
);

export default TermosDireitos;
